import React, { FC } from 'react'
import { SONG } from '../../../store/types'
import UserLink from '../../../utils/UserLink'
import { useModalClose } from '../../../hooks'
import { selectedTrack, selectTrack } from '../../../store/actions/track'
import { likeSong } from '../../../store/actions/songs'
import { connect } from 'react-redux'
import { addToQue, clearQue } from '../../../store/actions/queue'
import UIkit from 'uikit'
import { playOrPause } from '../../../store/actions/audio'
import { RootState } from '../../../store/reducers'
import { Track } from '../../../models/track'
import { User } from '../../../models/user'

interface Props {
  user: User
  selected: Track
  current: Track
  addToQue: Function
  selectTrack: Function
  playOrPause: Function
  isAuthenticated: boolean
}

const TrackModal: FC<Props> = ({
  selected,
  selectTrack,
  playOrPause,
  addToQue,
  user,
  current,
  isAuthenticated,
}) => {
  const { id, username } = selected
  useModalClose('track-modal', 'tmc')

  const selectSong = (track: Track) => {
    if (current.id !== id) {
      selectTrack(track)
      playOrPause()
    } else {
      selectTrack(track)
      playOrPause()
    }
  }

  return (
    <div id="track-modal" data-uk-modal="stack: true">
      <div className="uk-modal-dialog uk-border-rounded  uk-margin-auto-vertical">
        <button
          className="uk-modal-close-default"
          type="button"
          data-uk-close
        ></button>
        <div
          className="player-track-options uk-padding "
          //  uk-dropdown="pos: bottom-right; mode: click;delay-hide: 100; animation: uk-animation-scale-up"
        >
          <ul className="uk-nav uk-dropdown-nav">
            <li
              className="tmc"
              onClick={() => {
                selectSong(selected)
              }}
            >
              <span>Play</span>
            </li>
            <li
              className="tmc"
              onClick={() => {
                if (user && id) {
                  likeSong(id)
                } else {
                  UIkit.modal.dialog(
                    `<p class="uk-modal-body">Login to use this feature</p>`
                  )
                }
              }}
            >
              <span>Like</span>
            </li>

            <li className="tmc uk-nav-divider"></li>
            <li
              className="tmc"
              // uk-toggle="target: #lyrics"
              onClick={() => {
                const el = document.getElementById('lyrics')
                if (el) UIkit.modal(el).show()
              }}
            >
              <span>View lyrics</span>
            </li>
            {username && (
              <li className="tmc">
                <UserLink params={{ username }}>
                  <span>View artist</span>
                </UserLink>
              </li>
            )}

            <li className="tmc uk-nav-divider"></li>
            {user && isAuthenticated && (
              <>
                <li
                  className="tmc"
                  // uk-toggle="target: #playlists-modal"
                  onClick={() => {
                    selectedTrack(selected)
                    const el = document.getElementById('playlists-modal')
                    if (el) UIkit.modal(el).show()
                  }}
                >
                  <span>Add to playlist</span>
                </li>
                {user.accountType === `artist` && selected.uid === user.id && (
                  <li
                    className="tmc"
                    // uk-toggle="target: #album-modal"
                    onClick={() => {
                      selectedTrack(selected)
                      const el = document.getElementById('album-modal')
                      if (el) UIkit.modal(el).show()
                    }}
                  >
                    <span>Add to album</span>
                  </li>
                )}
              </>
            )}
            <li
              className="tmc"
              onClick={() => {
                addToQue({ content: selected, modifier: SONG })
              }}
            >
              <span>Add to Que</span>
            </li>
            <li className="tmc uk-nav-divider"></li>
            {/* <li className="tmc" onClick={clearQue}>
              <span>Clear Que</span>
            </li> */}
            <li uk-toggle="target: #que-view">
              <span>View Que</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  selected: state.songs.selected,
  current: state.songs.current,
  user: state.auth.user,
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps, {
  clearQue,
  addToQue,
  selectTrack,
  playOrPause,
})(TrackModal)
